// extracted by mini-css-extract-plugin
module.exports = {"binaryConverterContainer":"BinaryConverterDark_binaryConverterContainer__5itpR"};